<template>
  <div class="category-manage">
    <div
      v-if="dialogValue"
      class="attr-dialog global"
      :close-on-click-modal="false"
    >
      <div class="c-manager-header">
        <div class="back" @click="dialogValue = false">
          <i class="el-icon-arrow-left"></i> 作品类目配置
        </div>
        <el-button round type="primary" @click="handleAdd">添加类目</el-button>
      </div>
      <div class="c-manaer-body">
        <el-table
          :data="tagsTableData"
          class="table-area"
          element-loading-text="拼命查询中, 请稍候"
          element-loading-spinner="el-icon-loading"
          style="width: 100%"
        >
          <el-table-column prop="name" label="类别" width="300">
          </el-table-column>
          <el-table-column prop="templateCount" label="当前模板数"> </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <a
                class="c-main-color"
                :disabled="scope.$index === 0"
                @click="handleMove('up', scope.$index, scope.row)"
                >上移</a
              >
              &emsp;
              <a
                class="c-main-color"
                :disabled="scope.$index === tagsTableData.length - 1"
                @click="handleMove('down', scope.$index, scope.row)"
                >下移</a
              >
              &emsp;
              <el-dropdown
                @command="cmd => handleDelete(cmd, scope.$index, scope.row)"
              >
                <a class="c-main-color">更多</a>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="update"
                    >修改类目名</el-dropdown-item
                  >
                  <el-dropdown-item command="delete"
                    ><span class="c-text-red"
                      >删除该类目</span
                    ></el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog
        :visible.sync="addDialogValue"
        :title="type === 'add' ? '创建类目' : '编辑类目'"
        custom-class="project-form-dialog"
        class="global-dialog"
        width="540px"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
      >
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-width="73px"
        >
          <el-form-item label="类目名称" prop="name">
            <el-input type="text" v-model="ruleForm.name"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="handleAddCancel">取消</el-button>
          <el-button type="primary" @click="handleAddConfirm" :loading="loading"
            >保存</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  getCategoryList,
  addCategory,
  editCategory,
  delCategory,
  moveDown,
  moveUp
} from '@/request/api/category'
import { mapGetters } from 'vuex'
export default {
  props: {
    value: Boolean
  },
  data () {
    return {
      tagsTableData: [],
      addDialogValue: false,
      type: 'add',
      loading: false,
      ruleForm: {
        id: '',
        name: ''
      },
      rules: {
        name: [{ required: true, message: '请输入类目名称', trigger: 'blur' }]
      }
    }
  },
  computed: {
    ...mapGetters({
      publicProjectId: 'app/publicProjectId'
    }),
    dialogValue: {
      get () {
        return this.value
      },
      set (v) {
        this.$emit('input', v)
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.getCategoryList()
    },
    getCategoryList () {
      getCategoryList(this.publicProjectId).then(d => {
        this.tagsTableData = d || []
      })
    },
    handleDelete (cmd, index, item) {
      if (cmd === 'update') {
        this.ruleForm.name = item.name
        this.ruleForm.id = item.id
        this.type = 'edit'
        this.addDialogValue = true
      } else if (cmd === 'delete') {
        this.$confirm(`确定删除“${item.name}”类目？`, '', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
          delCategory(item.id).then(() => {
            this.getCategoryList()
          })
        }).catch(() => {
        })
      }
    },
    handleAddCancel () {
      this.addDialogValue = false
    },
    handleAddConfirm () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          if (this.type === 'add') {
            addCategory({
              name: this.ruleForm.name,
              projectId: this.publicProjectId
            }).then(() => {
              this.getCategoryList()
            }).finally(() => {
              this.loading = false
              this.addDialogValue = false
            })
          } else if (this.type === 'edit') {
            editCategory({
              id: this.ruleForm.id,
              name: this.ruleForm.name
            }).then(() => {
              this.getCategoryList()
            }).finally(() => {
              this.loading = false
              this.addDialogValue = false
            })
          }
        } else {
          return false;
        }
      });
    },
    handleAdd () { 
      this.type = 'add'
      this.ruleForm.id = ''
      this.ruleForm.name = ''
      this.addDialogValue = true
    },
    handleMove (cmd, index, item) {
      if (cmd === 'up') {
        moveUp(item.id).then(() => { this.getCategoryList() })
      } else if (cmd === 'down') {
        moveDown(item.id).then(() => { this.getCategoryList() })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.category-manage {
  display: inline-block;
  .c-manager-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 64px;
    padding: 0 24px;
    font-weight: 600;
    font-size: 16px;
    color: #2e3138;
    background-color: #f9fafd;
    .back {
      cursor: pointer;
    }
  }
  .c-manaer-body {
    padding: 24px;
    flex: 1;
    height: 0;
    overflow-y: auto;
  }
}
.attr-dialog {
  display: flex;
  flex-direction: column;
  position: absolute;
  background: #f1f4fb;
}
.c-text-red {
  color: #ff3333;
}
.c-main-color {
  &[disabled='disabled'] {
    color: #8f96a3 !important;
    cursor: no-drop !important;
  }
}
</style>
